import { AxiosRequestConfig } from "axios";

export const postSubscriptionConfig = (
  authorization: string | undefined,
  origin?: string,
  xForwardedFor?: string
): AxiosRequestConfig => ({
  method: "post",
  url: `/me/subscription`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: authorization && `Bearer ${authorization}`,
    ...(origin && { origin }),
    ...(xForwardedFor !== undefined && { "server-side-client-ip": xForwardedFor }),
  },
});
